import React from 'react';
import TaxGenerationForm from './TaxGenerationForm';

const GenerateTax = () => {
  return (
    <div className="p-4">
      <TaxGenerationForm />
    </div>
  );
};

export default GenerateTax;
